module.exports = __webpack_public_path__ + "static/media/sobel.e51e1cdf.png";